import React from 'react';

import PageNotFoundController from './page-not-found.controller';
import { PageNotFoundProps } from './page-not-found.model';

const PageNotFoundScreen: React.FC<PageNotFoundProps> = (props) => {
  return <PageNotFoundController {...props} />;
};
export default PageNotFoundScreen;
